import React from 'react';
import { DatePicker, Flex, Switch } from 'antd';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RangePickerProps } from 'antd/es/date-picker';
import dayjs from 'dayjs';

import { useDevExTheme } from 'jf/common/themes/DevExTheme';
import { DevExCard } from 'jf/components/DevExCard';
import { DevExText } from 'jf/components/DevExText';

import { useStudyBuilderState } from '../StudyBuilderState';
import { useStudyUpdater } from '../useStudyUpdater';

export const ScheduleStudyStep: React.FC = () => {
  const theme = useDevExTheme();
  const state = useStudyBuilderState();
  const studyUpdater = useStudyUpdater(state.studyRef);
  const disabledDate: RangePickerProps['disabledDate'] = (current) => {
    // Can not select days before today and today
    return current && current < dayjs().endOf('day');
  };

  return (
    <Flex vertical gap={theme.variable.spacing.lg}>
      <DevExText
        fontSize={'xl'}
        style={{ fontSize: theme.variable.fontSize.xl, textAlign: 'center' }}
      >
        Schedule your survey
      </DevExText>
      <DevExCard title={'Survey Reminders'}>
        <Flex align="center" gap={theme.variable.spacing.sm}>
          <Switch
            value={state.enabledScheduling}
            size="small"
            onChange={(checked) => {
              state.update({ enabledScheduling: checked });
              studyUpdater.update({ enabledScheduling: checked });
            }}
          />
          <DevExText>Send automatic reminders to respondents who haven't responded</DevExText>
        </Flex>
        <Flex gap={theme.variable.spacing.sm}>
          <FontAwesomeIcon icon={faInfoCircle} style={{ color: theme.color.text.secondary }} />
          <DevExText type="secondary">
            If enabled, reminders will automatically be sent every 2 days via Slack to respondents
            who have not yet responded. You can disable reminders at any point while the survey is
            open.
          </DevExText>
        </Flex>
      </DevExCard>
      <DevExCard title={'Survey Close Date'}>
        <Flex align="center" gap={theme.variable.spacing.sm}>
          <DevExText>This survey will close automatically</DevExText>
          <DatePicker
            disabledDate={disabledDate}
            value={dayjs(state.scheduledCloseDate)}
            onChange={(date) => {
              state.update({ scheduledCloseDate: date.toISOString() });
              studyUpdater.update({ scheduledCloseDate: date.toISOString() });
            }}
          />
        </Flex>
        <Flex gap={theme.variable.spacing.sm}>
          <FontAwesomeIcon icon={faInfoCircle} style={{ color: theme.color.text.secondary }} />
          <DevExText type="secondary">
            The survey will close on the selected date at 9 AM EST. You will be notified in Slack 2
            days before the survey closes. You can close it manually before then or extend the
            deadline while the survey is still open.
          </DevExText>
        </Flex>
      </DevExCard>
    </Flex>
  );
};
